import { Routes, Route } from 'react-router-dom';

import Logout from './Auth/Logout';
import Login from './Auth/Login';
import RequestPasswordReset from './Auth/RequestPasswordReset';
import PasswordReset from './Auth/PasswordReset';
import Register from './Auth/Register';
import RegisterConfirmation from './Auth/RegisterConfirmation';
import AuthorisedParticipant from './AuthorisedParticipant';

function Participant () 
{
    return  <Routes>
                <Route path="/secure/*" element={ <AuthorisedParticipant /> } />
                <Route path="/logout" element={ <Logout /> } />
                <Route path="/login" element={ <Login /> } />
                <Route path="/requestpasswordreset" element={ <RequestPasswordReset /> } />
                <Route path="/passwordreset" element={ <PasswordReset /> } />
                <Route path="/register" element={ <Register /> } />
                <Route path="/register/confirm" element={ <RegisterConfirmation /> } />
            </Routes>
}

export default Participant;
